import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { EvSpinner } from '@evinced-private/ui-common';

import { MfaRouter } from 'src/apps/mfa/router/MfaRouter';
import { getMobileRedirectPath } from 'src/apps/mobile-common/helpers/MobileRedirectHelper';
import { MobileRedirect } from 'src/apps/mobile-common/pages/mobile-redirect/MobileRedirect';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';

export const MfaRedirect: FC = () => {
	const location = useLocation();
	const { configuration } = useConfiguration();

	if (!configuration) {
		return <EvSpinner />;
	}

	const redirectPath = getMobileRedirectPath(
		location,
		RoutesHelper.getMfaDashboardPath(),
		RoutesHelper.getMfaV1DashboardPath()
	);

	return <MobileRedirect isNewPlatformEnabled redirectTo={redirectPath} router={<MfaRouter />} />;
};
